import axios from 'axios';
import { Treatment } from 'views/self-service/features/treatment-catalog/types/treatment.type';
import { CreateTreatmentInput } from '../types/create-treatment-input.type';

// POST TREATMENTS
// /ewosapi/v1/shrimps/Treatment/{globalSiteId}
export const postTreatment = async (globalCompanyId: string, request: CreateTreatmentInput): Promise<Treatment> => {
  const res = await axios.post<Treatment>(`/ewosapi/v1/shrimps/Treatment/${globalCompanyId}`, request);
  return res.data;
};
